/**
 * pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 * pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */

export function pathOr<T>(defaultValue: T, path: string | (string | number)[], obj: any): T {
  const pathArray = typeof path === 'string' ? path.split('.').filter(Boolean) : path;
  let current: any = obj;

  for (const key of pathArray) {
    if (current == null || typeof current !== 'object' || !(key in current)) {
      return defaultValue;
    }
    current = current[key];
  }

  return current;
}
